__turbopack_context__.v({
  "amenities_child": "Rooms-module-scss-module__5WEY6W__amenities_child",
  "amenities_main": "Rooms-module-scss-module__5WEY6W__amenities_main",
  "bg_image": "Rooms-module-scss-module__5WEY6W__bg_image",
  "booking_col": "Rooms-module-scss-module__5WEY6W__booking_col",
  "booking_cont": "Rooms-module-scss-module__5WEY6W__booking_cont",
  "button_col": "Rooms-module-scss-module__5WEY6W__button_col",
  "check_now_btn": "Rooms-module-scss-module__5WEY6W__check_now_btn",
  "delux_icone": "Rooms-module-scss-module__5WEY6W__delux_icone",
  "gallery_child": "Rooms-module-scss-module__5WEY6W__gallery_child",
  "gallery_main": "Rooms-module-scss-module__5WEY6W__gallery_main",
  "right_amen": "Rooms-module-scss-module__5WEY6W__right_amen",
  "rooms": "Rooms-module-scss-module__5WEY6W__rooms",
  "rooms_center": "Rooms-module-scss-module__5WEY6W__rooms_center",
  "rooms_center_amen": "Rooms-module-scss-module__5WEY6W__rooms_center_amen",
  "rooms_center_desc": "Rooms-module-scss-module__5WEY6W__rooms_center_desc",
  "rooms_left": "Rooms-module-scss-module__5WEY6W__rooms_left",
  "rooms_main": "Rooms-module-scss-module__5WEY6W__rooms_main",
  "rooms_right": "Rooms-module-scss-module__5WEY6W__rooms_right",
  "similar_room_child": "Rooms-module-scss-module__5WEY6W__similar_room_child",
  "similar_rooms": "Rooms-module-scss-module__5WEY6W__similar_rooms",
  "similer_inner_text": "Rooms-module-scss-module__5WEY6W__similer_inner_text",
  "single_blog": "Rooms-module-scss-module__5WEY6W__single_blog",
});
